'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createCandyMachineV2 = require('./operations/createCandyMachineV2.cjs');
var deleteCandyMachineV2 = require('./operations/deleteCandyMachineV2.cjs');
var insertItemsToCandyMachineV2 = require('./operations/insertItemsToCandyMachineV2.cjs');
var mintCandyMachineV2 = require('./operations/mintCandyMachineV2.cjs');
var updateCandyMachineV2 = require('./operations/updateCandyMachineV2.cjs');

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the Candy Machine module.
 *
 * @see {@link CandyMachinesV2Client}
 * @group Module Builders
 */
class CandyMachinesV2BuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  /** {@inheritDoc createCandyMachineV2Builder} */
  create(input, options) {
    return createCandyMachineV2.createCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc deleteCandyMachineV2Builder} */
  delete(input, options) {
    return deleteCandyMachineV2.deleteCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc insertItemsToCandyMachineV2Builder} */
  insertItems(input, options) {
    return insertItemsToCandyMachineV2.insertItemsToCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc mintCandyMachineV2Builder} */
  mint(input, options) {
    return mintCandyMachineV2.mintCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc updateCandyMachineV2Builder} */
  update(input, options) {
    return updateCandyMachineV2.updateCandyMachineV2Builder(this.metaplex, input, options);
  }
}

exports.CandyMachinesV2BuildersClient = CandyMachinesV2BuildersClient;
//# sourceMappingURL=CandyMachinesV2BuildersClient.cjs.map
